<template>
    <div class="w-full md:w-1/2 p-4">

            <!--<h3 class="text-center pb-4"><span class="text-green-400">{{type}}</span> Notifications</h3>-->
        <strong>Realtime <a
            v-show="realtime_categories.length > 0"
            class="font-medium text-blue-500 hover:text-gray-100 transition duration-150 ease-in-out"
            :href="route('realtime.remove.all')"> - Remove All</a></strong>
<ul>
                <li class="mb-2" v-for="category in realtime_categories"><i class="fas fa-fw fa-check mr-2"></i>{{ category.category.name }}</li>
                <li class="mb-2" v-if="realtime_count > realtime_categories.length">and {{ realtime_count - realtime_categories.length}} more...</li>
</ul>
        <a :href="route('categories.index', 'realtime')">
            <button class="mb-5 fw-btn fw-btn-green w-full"
                    style="outline: none;">Edit Realtime Notifications
            </button>
        </a>

        <strong>Daily <a v-show="daily_categories.length > 0"
                         class="font-medium text-blue-500 hover:text-gray-100 transition duration-150 ease-in-out"
                         :href="route('daily.remove.all')"> - Remove All</a></strong>
        <ul>
            <li class="mb-2" v-for="category in daily_categories"><i class="fas fa-fw fa-check mr-2"></i>{{ category.category.name }}</li>
            <li class="mb-2" v-if="daily_count > daily_categories.length">and {{ daily_count - daily_categories.length}} more...</li>
        </ul>

        <a :href="route('categories.index', 'daily')">
            <button class="fw-btn fw-btn-green w-full"
                    style="outline: none;">Edit Daily Notifications
            </button>
        </a>


    </div>
</template>

<script>
export default {
    name: "NotifyMe",
    props: {
        realtime_categories: {
            type: Array,
            required: true
        },
        daily_categories: {
            type: Array,
            required: true
        },
        realtime_count: {
            type: Number,
            required: true
        },
        daily_count: {
            type: Number,
            required: true
        },
        channels: {
            type: Array,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        frequency: {
            type: String,
            required: true,
            default: 'realtime'
        }
    }

}
</script>

<style scoped>

</style>
